import { SET_DATA, RESET_DATA } from 'modules/Countries/types'

const initialState = {
  loading: false,
  loaded: false,
  data: [],
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DATA:
      return { ...state, ...action.payload }
    case RESET_DATA:
      return { ...initialState }
    default:
      return state
  }
}

export default reducer
